import { useMutation, useQueryClient } from "@tanstack/react-query";

import { exploreImagesQueryKey } from "@/hooks/queries/useGetExploreImages";
import { guacHttpClient } from "@/lib/http";
import { ExploreImage } from "@/types";

export function useDeleteRemoveExploreImages() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ ids }: { ids: string[] }) => {
      await guacHttpClient.delete("explore-images", { data: { ids } });
    },
    onSuccess: (_, { ids }) => {
      const deletedIds = new Set(ids);
      queryClient.setQueryData<ExploreImage[]>(
        exploreImagesQueryKey,
        (images) => images?.filter((image) => !deletedIds.has(image.id)),
      );
    },
  });
}
